import { apiClient, unwrap } from './client';
import type { ApiEnvelope } from './types';

/** GET /v1/dataroom/invites — the summaries the case checklist lists. */
export interface DataroomInviteSummary {
  inviteId: string;
  entityId: string;
  caseRef?: string | null;
  locale: string;
  status: string;
  applicantLabel?: string | null;
  taskCount: number;
  createdAt: string;
  expiresAt: string;
  consumedAt?: string | null;
}

export async function listDataroomInvites(entityId: string): Promise<DataroomInviteSummary[]> {
  const { data } = await apiClient.get<ApiEnvelope<DataroomInviteSummary[]>>('/v1/dataroom/invites', {
    params: { entityId },
  });
  return unwrap(data);
}
